import { useActions } from "./useActions";
import { useSelector } from "react-redux";

import { openQuotePopup, closeQuotePopup } from "../redux/page/page.actions";
import {
    successLoadQuotePopup,
    requestLoadQuotePopup,
} from "../redux/home-insurance/home-insurance.actions";

const useQuotePopup = () => {
    const { opened } = useSelector(state => state.Page.quotePopup);
    const actions = useActions({
        openQuotePopup,
        closeQuotePopup,
        successLoadQuotePopup,
        requestLoadQuotePopup,
    });
    return {
        opened,
        successLoadQuotePopup: actions.successLoadQuotePopup,
        requestLoadQuotePopup: actions.requestLoadQuotePopup,
        openQuotePopup: actions.openQuotePopup,
        closeQuotePopup: actions.closeQuotePopup,
    };
};

export default useQuotePopup;
